<div layout="row" [ngClass]="styles.reportTabContentHeader">

	<div [ngClass]="styles.reportTitle" [innerHTML]="'<' + headerTag + '>' + escape(header) + '</' + headerTag + '>'"></div>

	<date-range-picker *ngIf="showDateFilter" #dateRangePicker class="margin-right-10 margin-left-auto" [defaultLabel]="'Reports_VideoReports_LastNDays' | translate : { '0' : 30 }" [dropdown]="true" [maxDateRange]="365" [ngModel]="AnalyticsService.dateFilter$ | async" (ngModelChange)="onDateRangeChanged($event)">
	</date-range-picker>
</div>

<ng-content></ng-content>
